import { useNavigate, useParams } from 'react-router';
import { Helmet } from 'react-helmet';

import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import SchoolCard from '../../components/SchoolCard/SchoolCard';
import Carousel from 'react-multi-carousel';

const SingleSubject = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  let studentData = JSON.parse(localStorage.getItem('userData'));
  let subjectData = studentData?.subjects?.filter(
    (el) => JSON.stringify(el.id) === id
  );

  console.log(subjectData);

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      paritialVisibilityGutter: 60,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      paritialVisibilityGutter: 60,
    },
  };

  return (
    <>
      <Helmet>
        <title>PL by Edves | Subject</title>
      </Helmet>
      <DashboardHeader />
      <div className='single-subject'>
        <div
          className='single-subject__hero'
          style={{
            background: `linear-gradient( 
              rgba(54, 54, 165, 0.7) 100%, 
              rgba(54, 54, 165, 0.7)100%),url(${subjectData[0]?.banner}) no-repeat`,
            backgroundSize: 'cover',
          }}
        >
          <div className='single-subject__hero__breadcrumbs'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                fill='white'
              />
            </svg>
            <p>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/dashboard')}
              >
                Home
              </span>{' '}
              | {subjectData[0]?.name}
            </p>
          </div>
          <h3>{subjectData[0]?.name}</h3>
        </div>

        <div className='dashboard-body' style={{ marginTop: '60px' }}>
          <div
            className='recommended-section__title'
            style={{ marginBottom: '40px' }}
          >
            <h2>Schools offering {subjectData[0]?.name}</h2>
            <p>{subjectData[0]?.schools_count} school(s) </p>
          </div>
          <Carousel
            responsive={responsive}
            showDots={true}
            itemClass={`carouselItem`}
          >
            {subjectData[0]?.schools?.length > 0 ? (
              subjectData[0]?.schools?.map((el) => (
                <SchoolCard
                  type='school'
                  lessonCount={2}
                  key={el.id}
                  schoolLogo={el.logo}
                  schoolHeader={el.banner}
                  schoolName={el.name}
                  subjectNo={Math.floor(Math.random() * 10) + 1}
                  description={el.bio}
                  subjectHeader={el.header}
                  location={`${el.state},${el.country}`}
                  selectSchool={() => {
                    navigate(`/schools/${el.id}`);
                  }}
                  page='dashboard'
                />
              ))
            ) : (
              <div>No schools taking this subject yet</div>
            )}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default SingleSubject;
